module.exports = __webpack_public_path__ + "static/media/DL_es2.83b81940.jpg";